class LoadingMessages {
  static Messages = [
    {
      situation: "PAGADA",
      message: "Generando pago.",
      color: "#8bc34a",
    },
    {
      situation: "LABRADA",
      message: "Guardando Cambios",
      color: "#00c3a8",
    },
    {
      situation: "NOTIFICADA",
      message: "Guardando Cambios",
      color: "var(--color-yellow-muni)",
    },
    {
      situation: "DESCARGO",
      message: "Guardando Cambios",
      color: "var(--color-error)",
    },
    {
      situation: "SENTENCIA",
      message: "Guardando Cambios",
      color: "#0057d9",
    },
    {
      situation: "RECURRIDA",
      message: "Guardando Cambios",
      color: "var(--color-error)",
    },
    {
      situation: "SENTENCIA FIRME",
      message: "Guardando Cambios",
      color: "#009688",
    },
    {
      situation: "DESESTIMADA",
      message: "Guardando Cambios",
      color: "#f44336",
    },
    {
      situation: "ARCHIVADA", //
      message: "Guardando Cambios",
      color: "#9e9e9e",
    },
    {
      situation: "SavingTitular",
      message: "Guardando titular del vehiculo",
      color: "#9e9e9e",
    },
    {
      situation: "SavingVehicle",
      message: "Guardando datos del vehiculo",
      color: "#9e9e9e",
    },
    {
      situation: "UpdatingCover",
      message: "Guardando datos del nuevo titular",
      color: "#9e9e9e",
    },
    {
      situation: "UpdatingValue",
      message: "Actualizando Valor",
      color: "#9e9e9e",
    },
    {
      situation: "FetchingById",
      message: "Obteniendo informacion de la infracción",
      color: "#9e9e9e",
    },
    {
      situation: "UpdatingNotification",
      message: "Guardando datos de la notificación",
      color: "#9e9e9e",
    },
    {
      situation: "SchedulingAppointment",
      message: "Guardando datos del turno",
      color: "#9e9e9e",
    },
    {
      situation: "SavingUser",
      message: "Guardando datos del Usuario",
      color: "#9e9e9e",
    },
    {
      situation: "SavingObservation",
      message: "Guardando la observación",
      color: "#9e9e9e",
    },
    {
      situation: "unarchiveInfraction",
      message: "Desarchivando Infraccion",
      color: "#9e9e9e",
    },
    {
      situation: "SavingProcedure",
      message: "Guardando Trámite",
      color: "#9e9e9e",
    },
    {
      situation: "UpdatingAppointment",
      message: "Actualizando Turno",
      color: "#9e9e9e",
    },
    {
      situation: "FinishingAppointment",
      message: "Finalizando Turno",
      color: "#9e9e9e",
    },
    {
      situation: "SavingFile",
      message: "Guardando Documento",
      color: "#9e9e9e",
    },
    {
      situation: "SendingMassComm",
      message: "Enviando Comunicación masiva",
      color: "#9e9e9e",
    },
    {
      situation: "SendingSingleComm",
      message: "Enviando Comunicación",
      color: "#9e9e9e",
    },
    {
      situation: "SavingComment",
      message: "Guardando Comentario",
      color: "#9e9e9e",
    },
    {
      situation: "SendingWhatsapp",
      message: "Enviando mensaje por whatsapp",
      color: "#9e9e9e",
    },
    {
      situation: "SavingInteraction",
      message: "Guardando atención",
      color: "#9e9e9e",
    },
    {
      situation: "SavingTask",
      message: "Guardando datos",
      color: "#9e9e9e",
    },
    {
      situation: "Generating",
      message: "Generando",
      color: "#9e9e9e",
    },
  ];
}

export default LoadingMessages;
